import { render, staticRenderFns } from "./Softphone.vue?vue&type=template&id=840d858e"
import script from "./Softphone.vue?vue&type=script&lang=js"
export * from "./Softphone.vue?vue&type=script&lang=js"
import style0 from "./Softphone.vue?vue&type=style&index=0&id=840d858e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports